var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 96,
    viewBox: "0 0 92 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#EFF1F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0124 50.7005H43.12C43.6859 50.7005 44.1381 51.1606 44.1381 51.7353L44.0248 71.9766C44.0248 73.0693 45.4955 73.4142 45.9481 72.3793L59.9206 40.7524C60.2035 40.0625 59.6945 39.3148 58.959 39.3722L50.5301 39.602C49.9643 39.602 49.5121 39.1419 49.5121 38.5672L49.5125 19.9935C49.5689 18.9587 48.1547 18.6136 47.6457 19.5334L33.1074 49.2628C32.7681 49.9527 33.2771 50.7004 34.0122 50.7004L34.0124 50.7005Z",
    fill: "#B1BADA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 83,
    r: 13,
    fill: "#00BB29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84L70.5429 87.8144C70.7511 88.1267 71.2162 88.1068 71.3971 87.778L76.5 78.5",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.55f543f820eecf8b6204181adad5abf8.svg";
export { ForwardRef as ReactComponent };